module.exports = __webpack_public_path__ + "img/register-header.f3cf7246.png";